<template>
  <div>
    <b-overlay
        :show="loading"
        rounded="sm"
        no-fade
      >

  <b-card-code title="Usina">
    <b-card-text>
      <span>Atualize por aqui a usina: </span>
      <code>{{ this.$route.params.alias }}</code>
    </b-card-text>

    <b-row>
      <b-col
        cols="12"
        class="mb-2"
      >

      <label
        for="extension"
        class="mt-1"
      >Formato aceito: .csv</label>
      <b-form-file
        v-model="fileCSV"
        @change="formSubmitted($event)"
        id="extension"
        accept=".csv"
        placeholder="Selecione um CSV"
      />
      </b-col>
      
    </b-row>

  </b-card-code>
</b-overlay>
</div>
</template>

<script>
import BCardCode from '@core/components/b-card-code';
import { BFormFile, BCardText, BRow, BCol, BOverlay } from 'bootstrap-vue';
import useJwt from '@/auth/jwt/useJwt';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCardCode,
    BFormFile,
    BCardText,
    BRow,
    BCol,
    BOverlay,
    ToastificationContent
  },
  data() {
    return {
      fileCSV: [],
      loading: false
    }
  },
  methods: {
    async formSubmitted(event) {
      let params = new FormData();
      params.append('fileCSV', event.target.files[0]);
      params.append('alias', this.$route.params.alias);

      this.loading = true;
      await useJwt.requestWithFile('/api/usina/csv/upload/alias', params).then(request => {
        this.loading = false;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: request.data.status,
            text: request.data.msg,
            icon: request.data.status == 'success' ? 'CheckCircleIcon' : 'XCircleIcon',
            variant: request.data.status == 'success' ? 'success' : 'danger',
          },
        });
      });
    },
  }
}
</script>